export const Card = ({ children, className = '', hover = false, padding = true, noBorder = false }) => (
    <div className={`
    bg-white rounded-2xl shadow-sm 
    ${!noBorder ? 'border border-gray-100' : ''} 
    ${hover ? 'hover:shadow-md transition-shadow duration-200 cursor-pointer' : ''} 
    ${padding ? 'p-6' : ''} 
    ${className}
  `}>
        {children}
    </div>
);

export default Card;